import { Component, OnInit, Input } from '@angular/core';
import { PolicyState, PolicyStates } from '@shared/models/codebooks/policy-state';
import { Policy } from '@shared/models/policy';
import { Lob } from '@shared/models/lob-enum';
import { ActiveInsuranceGroup } from '@shared/models/active-insurance-group';
import { DataService } from '@core/services/data.service';
import { CommonService } from '@core/services/common.service';
import { ClaimService } from '@core/services/claim.service';
import { ClaimMyData } from 'app/models/claim-my-data';
import { TranslateService } from '@ngx-translate/core';
import { LOB } from '@shared/models/LOB';

@Component({
    selector: 'app-claim-policy-card',
    templateUrl: './claim-policy-card.component.html',
    styleUrls: ['./claim-policy-card.component.scss'],
    standalone: false
})
export class ClaimPolicyCardComponent implements OnInit {
    @Input() policy: Policy;
    @Input() state: PolicyState;

    readonly lob: typeof Lob = Lob;
    readonly policyStates: PolicyStates;

    public responsibility: string = '';
    public LOB = new LOB();

    constructor(
        private dataService: DataService,
        private claimService: ClaimService,
        public commonService: CommonService,
        private translateService: TranslateService
    ) {
        this.policyStates = this.dataService.policyStates;
    }

    ngOnInit(): void {
        if([1160,1161,1042,1043,1044].includes(this.policy.packageId)){
            this.responsibility = '_responsibility';
        }
    }

    getGroupByLobId(lobId: number): ActiveInsuranceGroup {
        return this.dataService.activeInsuranceGroups.find(group => group.lobIds.some(x => x === lobId));
    }

    gtm() {
        this.commonService.gtm();
    }

    claimMyData(policyNumber: string, detailTypeIdentifier: string, lob: number) {
        this.gtm();
        this.claimService.getMyClaimData(policyNumber, detailTypeIdentifier).subscribe((claimMyData: ClaimMyData) => {
            if (claimMyData && claimMyData.redirectUrl) {
                this.claimService.postClaimData(claimMyData).subscribe(x => {
                    window.open(claimMyData.redirectUrl, 'blank');
                });
            }

            if (!claimMyData || claimMyData.redirectUrl == null) {
                let url = this.translateService.instant('file-a-claim.' + this.commonService.env + '.lob_' + lob);
                window.open(url, 'blank');
            }
        });
    }
}
